import {
  Box,
  Container,
  HStack,
  Heading,
  Image,
  Stack,
  Text,
  VStack,
} from "@chakra-ui/react";
import React from "react";
import aboutAnime from "../assets/Images/aboutAnime.gif";
import { FaReact } from "react-icons/fa";



//AOS
import AOS from "aos";
import "aos/dist/aos.css";
AOS.init();

const About = () => {
  return (
    <Box id="about" className="about section" bg={"#1E1842"}>
      <div data-aos="fade-up">
        <Container maxW={{ base: "90%", md: "90%", lg: "8xl" }} padding={"0px"}>
          <HStack justifyContent={"center"} marginBottom={"50px"}>
            <Heading color={"#C651CD"} textAlign={"center"}>
              About
            </Heading>
            <Heading color={"white"} textAlign={"center"}>
              Me
            </Heading>
          </HStack>
          <Stack
            direction={{ base: "column", md: "column", lg: "row" }}
            spacing={"20px"}
          >
            <Image src={aboutAnime} alt="about-gif" title="about-section-gif" loading="lazy" w={{base: "288px", md: "600px", lg:"800px"}} h={{base: "180px", md: "350px", lg:"466px"}} />
            <VStack
              spacing={"20px"}
              w={{ base: "100%", md: "80%", lg: "90%" }}
              m={"auto"}
            >
              <div data-aos="fade-up">
                <HStack
                  alignItems={"flex-start"}
                  justifyContent={"flex-start"}
                  spacing={"10px"}
                >
                  <Box marginTop={"5px"}>
                    <FaReact color="#C651CD" fontSize={"20px"} />
                  </Box>
                  <Text
                    id="user-detail-intro"
                    color={"white"}
                    textAlign={"justify"}
                  >
                  Software Development Engineer II with 3 years of experience building scalable microservices, AI-driven platforms, and event-driven architectures.
                  </Text>
                </HStack>
              </div>

              <div data-aos="fade-up">
                <HStack
                  alignItems={"flex-start"}
                  justifyContent={"flex-start"}
                  spacing={"10px"}
                >
                  <Box marginTop={"5px"}>
                    <FaReact color="#C651CD" fontSize={"20px"} />
                  </Box>
                  <Text color={"white"} textAlign={"justify"}>
                   Proven track record of leading developer teams and delivering distributed systems that handle burst traffic of up to 250,000+ users, manage 400+ GB of operational data, and orchestrate 100,000+ asynchronous document workflows.
                  </Text>
                </HStack>
              </div>

              <div data-aos="fade-up">
                <HStack
                  alignItems={"flex-start"}
                  justifyContent={"flex-start"}
                  spacing={"10px"}
                >
                  <Box marginTop={"5px"}>
                    <FaReact color="#C651CD" fontSize={"20px"} />
                  </Box>
                  <Text color={"white"} textAlign={"justify"}>
                   Deeply experienced in high-level system design, multi-LLM integrations, vector search, and comprehensive backend performance optimization.
                  </Text>
                </HStack>
              </div>
            </VStack>
          </Stack>
        </Container>
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320">
          <path
            fill="#0F1624"
            fill-opacity="1"
            d="M0,256L48,261.3C96,267,192,277,288,272C384,267,480,245,576,229.3C672,213,768,203,864,213.3C960,224,1056,256,1152,266.7C1248,277,1344,267,1392,261.3L1440,256L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z"
          ></path>
        </svg>
      </div>
    </Box>
  );
};

export default About;
